// @ts-nocheck
import { useTrackCall } from './LiveTranscriptsProvider';

/**
 * LineTranscriptPreview — atome : aperçu des premiers mots du transcript d'un
 * appel actif, affiché sous le badge de statut dans une ligne de tableau
 * (style Minari). Ne montre que la fenêtre des ~10 premières secondes, fournie
 * par LiveTranscriptsProvider.
 *
 * Rend null tant qu'il n'y a aucun mot transcrit (pas de placeholder bruyant).
 */
export default function LineTranscriptPreview({ callId }) {
  const preview = useTrackCall(callId);
  const text = preview?.text?.trim();
  if (!text) return null;
  return (
    <p
      className="mt-1 text-[11px] leading-snug text-muted-foreground/90 italic truncate max-w-[260px]"
      title={text}
    >
      {text}
      {!preview.done && <span className="ml-0.5 animate-pulse">…</span>}
    </p>
  );
}
